// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconButton_icon__2nyqv","hover":"IconButton_hover__wxyQ8"};